// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pagination-wrapper__9gzXR","container":"pagination-container__w1TSW","page":"pagination-page__1TM9h","link":"pagination-link__2HWMJ","active":"pagination-active__gSZqa"};